import { render } from "./index.vue?vue&type=template&id=40f978b6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\dcuk-staging\\wp-content\\themes\\spotlight\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__